import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.dashboards.map(dashboard => ({
        text: dashboard.meta.name,
        value: dashboard.id
      })),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "text",
      "clearable": "",
      "item-value": "value",
      "label": _vm.$t('Dashboards.components.nestedDashboardOptionsEditor.dashboardSelect.label')
    },
    model: {
      value: _vm.nestedDashboardId,
      callback: function ($$v) {
        _vm.nestedDashboardId = $$v;
      },
      expression: "nestedDashboardId"
    }
  })], 1)], 1), _vm.nestedDashboardDefinition && _vm.nestedDashboardDefinition.customParameters ? _c('div', [_c(VRow, [_c(VCol, [_c(VSelect, {
    attrs: {
      "items": _vm.navigationTypeItems,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.nestedDashboardOptionsEditor.navigationType.label')
    },
    model: {
      value: _vm.navigationType,
      callback: function ($$v) {
        _vm.navigationType = $$v;
      },
      expression: "navigationType"
    }
  })], 1)], 1), _vm._v("\n\n    " + _vm._s(_vm.$t('Dashboards.components.nestedDashboardOptionsEditor.parametersSection.title')) + ":\n    "), _vm._l(Object.entries(_vm.nestedDashboardDefinition.customParameters), function ([key, defaultValue]) {
    return _c(VRow, {
      key: `nested_dashboard_parameter_${key}`
    }, [_c(VCol, [_c(VCombobox, {
      attrs: {
        "value": _vm.getByKey(`parameters.${key}`),
        "placeholder": `Default: ${defaultValue}`,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": key,
        "clearable": "",
        "items": _vm.eventParametersAsSelectItems
      },
      on: {
        "change": function ($event) {
          return _vm.setByKey(`parameters.${key}`, $event);
        }
      }
    })], 1)], 1);
  })], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };